import { render, staticRenderFns } from "./GuestProfileCard.vue?vue&type=template&id=b2495e1c&scoped=true&"
import script from "./GuestProfileCard.vue?vue&type=script&lang=js&"
export * from "./GuestProfileCard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/user-profile.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./GuestProfileCard.vue?vue&type=style&index=1&id=b2495e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2495e1c",
  null
  
)

export default component.exports